import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import CampaignSettingsCheckboxesCode from '@/presentation/components/campaign-settings/campaign-settings-checkboxes/campaign-settings-checkboxes.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new CampaignSettingsCheckboxesCode();

		return {
			campaignLiftExcluded: code.campaignLiftExcluded,
			persistGLParamRefLink: code.persistGLParamRefLink,
			isLoading: code.isLoading,
			campaignLiftExclusionNotAllowedForPartnershipType: code.campaignLiftExclusionNotAllowedForPartnershipType,
			isCampaignTypeCustomProductsOnly: code.isCampaignTypeCustomProductsOnly,
			userIsNotAllowedToEditCampaignExclusion: code.userIsNotAllowedToEditCampaignExclusion,
			setCampaignLiftExcludedBasedOnEvent: code.setCampaignLiftExcludedBasedOnEvent.bind(code),
			setPersistGLParamRefLinkBasedOnEvent: code.setPersistGLParamRefLinkBasedOnEvent.bind(code)
		};
	}
});
